import { useProfile } from './useProfile';

export const useIsLoggedIn = (): boolean | undefined => {
  const { profile, loading } = useProfile();

  if (loading) return;

  return !!profile;
};
